var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6584 26.0085L20.6946 19.0447C22.5923 16.7237 23.5253 13.7621 23.3007 10.7725C23.0761 7.78286 21.711 4.99394 19.4877 2.9826C17.2645 0.971252 14.3533 -0.108636 11.3561 -0.0336988C8.35904 0.0412383 5.50539 1.26527 3.38545 3.38521C1.26551 5.50514 0.0414824 8.3588 -0.0334547 11.3559C-0.108392 14.353 0.971496 17.2643 2.98284 19.4875C4.99419 21.7107 7.7831 23.0758 10.7727 23.3005C13.7623 23.5251 16.7239 22.5921 19.0449 20.6943L26.0087 27.6582C26.2288 27.8707 26.5235 27.9883 26.8294 27.9856C27.1353 27.983 27.4279 27.8603 27.6442 27.6439C27.8605 27.4276 27.9832 27.135 27.9859 26.8291C27.9885 26.5232 27.8709 26.2285 27.6584 26.0085ZM11.6669 21C9.82094 21 8.01644 20.4526 6.48158 19.427C4.94672 18.4015 3.75044 16.9438 3.04402 15.2384C2.33761 13.5329 2.15278 11.6563 2.5129 9.84581C2.87303 8.03532 3.76195 6.37228 5.06724 5.06699C6.37253 3.7617 8.03557 2.87279 9.84606 2.51266C11.6565 2.15253 13.5332 2.33736 15.2386 3.04378C16.9441 3.7502 18.4017 4.94647 19.4273 6.48133C20.4528 8.01619 21.0002 9.8207 21.0002 11.6667C20.9975 14.1412 20.0132 16.5135 18.2635 18.2633C16.5138 20.013 14.1414 20.9972 11.6669 21Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.799ccc6291d1bf6bb4ac28096a418818.svg";
export { ForwardRef as ReactComponent };